import { render, staticRenderFns } from "./ClassSuccess.vue?vue&type=template&id=6e9f5b28&"
import script from "./ClassSuccess.vue?vue&type=script&lang=js&"
export * from "./ClassSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports